<template>
    <page :showBackButton="true">
        <!-- <template v-slot:header>
      <ion-title>Spontanrückzahlung</ion-title>
    </template> -->
        <contract-card :contractId="contractId"></contract-card>
        <!-- Fixed Bug when clicking on enter -->
        <!-- <form> -->
        <ion-card class="-light">
            <ion-grid>
                <ion-row>
                    <ion-col size="12">
                        <h2>Spontanrückzahlung</h2>
                        Welchen Betrag möchtest du einzahlen?
                        <base-input
                            class="ion-margin-vertical"
                            placeholder="Betrag eingeben"
                            id="betrag"
                            inputmode="decimal"
                            v-model="betrag"
                            type="number"
                            min="0"
                        ></base-input>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="6">
                        <ion-button
                            class="ion-no-margin"
                            expand="block"
                            fill="outline"
                            @click="formSubmit(false)"
                            :disabled="!(betrag > 0)"
                            >Simulieren</ion-button
                        >
                    </ion-col>
                    <ion-col size="6">
                        <ion-button
                            class="ion-no-margin"
                            expand="block"
                            @click="formSubmit(true)"
                            :disabled="!(betrag > 0) || !isPaymentPossible"
                            >Einzahlen</ion-button
                        >
                    </ion-col>
                </ion-row>

                <ion-row class="ion-margin-top">
                    <ion-col size="12">
                        Verbleibender Einzahlungsbetrag<br />
                        <b>{{
                            $store.state.spontanrueckzahlung.details
                                .maxSpontanEinzahlung | currency
                        }}</b>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-grid>
            <!-- <ion-row>
          <ion-col size="6">
            <ion-button
              expand="block"
              fill="outline"
              @click="formSubmit(false)"
              :disabled="!(betrag > 0)"
            >Simulieren</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button
              expand="block"
              @click="formSubmit(true)"
              :disabled="!(betrag > 0)"
            >Einzahlen</ion-button>
          </ion-col>
        </ion-row> -->
            <ion-row class="ion-margin-top">
                <ion-col size="12">
                    Eingezahlt<br />
                    <b>{{
                        $store.state.spontanrueckzahlung.details
                            .summeSpontanEinzahlungen | currency
                    }}</b
                    ><br />
                    <ion-progress-bar
                        class="ion-margin-top ion-margin-bottom"
                        :value="spontanProgress"
                    ></ion-progress-bar>
                    Mögliche Spontanrückzahlung:
                    <b>{{
                        $store.state.spontanrueckzahlung.details.spontanLimit
                            | currency
                    }}</b>
                </ion-col>
            </ion-row>
            <ion-row class="ion-margin-top">
                <ion-col size="12">
                    Aktueller Kreditsaldo<br />
                    <b>{{
                        $store.state.spontanrueckzahlung.details.aktuellerSaldo
                            | currency
                    }}</b
                    ><br />
                    <ion-progress-bar
                        class="ion-margin-top ion-margin-bottom"
                        :value="creditProgress"
                    ></ion-progress-bar>
                    Ursprüngliche Kreditsumme:
                    <b>{{
                        $store.state.spontanrueckzahlung.details.darlehensSumme
                            | currency
                    }}</b>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!-- </form> -->
        <!-- <ion-list class="ion-margin-top">
      <ion-list-header>
        <ion-label>Details</ion-label>
      </ion-list-header>
      <template v-for="(value, key) in $store.state.spontanrueckzahlung.details">
        <ion-item
          :key="key"
          v-if="key in detailsConfig"
        >
          <ion-label class="ion-text-capitalize">{{ detailsConfig[key] }}</ion-label>
          <b
            class="ion-text-capitalize"
            slot="end"
          >{{ value | currency }}</b>
        </ion-item>
      </template>
    </ion-list> -->
    </page>
</template>

<script>
import Page from "@/components/Page";
import { parseCurrencyToFloat } from "@/utils/number";
import BaseInput from "@/components/BaseInput";
import ContractCard from "@/components/ContractCard";
import { spontanZahlungCheck, spontanZahlung } from "@/api/spontanrueckzahlung";
import SpontanrueckzahlungModal from "@/components/SpontanrueckzahlungModal";
import { parseValueToCurrency } from "@/utils/number";

export default {
    components: { Page, BaseInput, ContractCard },
    props: ["contractId"],
    data() {
        return {
            betrag: "",
            detailsConfig: {
                summeEinzahlungen: "Bisherige Einzahlungen",
                summeSpontanEinzahlungen: "Bisherige Spontanrückzahlungen",
            },
            isPaymentPossible: true,
        };
    },
    mounted() {
        this.$store.cache
            .dispatch("spontanrueckzahlung/spontanZahlungCheck")
            .then(() => {
                this.$ionic.alertController
                    .create({
                        header: "Hinweis",
                        message:
                            "Bei Darlehensverträgen mit Wohnbauförderung kann die Durchführung der SpontanRückzahlung (Sondertilgungen) - je nach gesetzlichen Bedingungen der Wohnbauförderung in den Bundesländern - zu einem Verlust der Förderung führen.",
                        buttons: ["Verstanden"],
                    })
                    .then((a) => {
                        a.present();
                    });
            });
        const today = new Date();
        if (today.getMonth() === 11) {
            if (today.getDate() >= 15) {
                this.isPaymentPossible = false;
            }
            this.$ionic.alertController
                .create({
                    header: "Bitte beachten",
                    message:
                        "Von 15.12. bis 31.12. ist eine Spontanrückzahlung aufgrund des Jahresabschlusses nicht möglich. Ab 1. Jänner können Spontanrückzahlungen wieder durchgeführt werden.",
                    buttons: ["Verstanden"],
                })
                .then((a) => {
                    a.present();
                });
        }
        this.$on("betrag-einzahlen", () => {
            this.formSubmit(true, true);
        });
    },
    methods: {
        formSubmit(confirmation, closeSpontanrueckzahlungModal) {
            if (!confirmation) {
                this.$store.commit("setLoading", true);
                spontanZahlungCheck(this.betrag).then((response) => {
                    if (response.data.Status === 200) {
                        this.$ionic.modalController
                            .create({
                                component: SpontanrueckzahlungModal,
                                componentProps: {
                                    propsData: {
                                        betrag: this.betrag,
                                        result: response.data.Result,
                                        isPaymentPossible: this
                                            .isPaymentPossible,
                                    },
                                    parent: this,
                                },
                            })
                            .then((m) => m.present());
                    }
                });
            } else {
                this.$ionic.alertController
                    .create({
                        header: "Spontanrückzahlung bestätigen",
                        message:
                            "Möchtest du " +
                            parseValueToCurrency(this.betrag) +
                            " jetzt zurückzahlen? Der Betrag wird von deinem hinterlegten Girokonto abgezogen.",
                        buttons: [
                            {
                                text: "Abbrechen",
                                role: "cancel",
                            },
                            {
                                text: "Betrag einzahlen",
                                handler: () => {
                                    this.$store.commit("setLoading", true);
                                    spontanZahlung(this.betrag).then(
                                        (response) => {
                                            if (response.data.Status === 200) {
                                                this.$store.cache.delete(
                                                    "spontanrueckzahlung/spontanZahlungCheck"
                                                );
                                                this.$store.cache.dispatch(
                                                    "spontanrueckzahlung/spontanZahlungCheck"
                                                );
                                                this.betrag = "";
                                                this.$ionic.alertController
                                                    .create({
                                                        header:
                                                            "Betrag eingezahlt",
                                                        message:
                                                            "Deine Spontanrückzahlung wurde erfolgreich durchgeführt und der SEPA-Einzug zum nächstmöglichen Termin vorgemerkt.",
                                                        buttons: [
                                                            {
                                                                text: "Ok",
                                                            },
                                                        ],
                                                    })
                                                    .then((a) => {
                                                        a.onDidDismiss().then(
                                                            () => {
                                                                if (
                                                                    closeSpontanrueckzahlungModal
                                                                ) {
                                                                    this.$ionic.modalController.dismiss();
                                                                }
                                                                this.$store.commit(
                                                                    "setAskForRating",
                                                                    true
                                                                );
                                                            }
                                                        );
                                                        a.present();
                                                    });
                                            }
                                        }
                                    );
                                },
                            },
                        ],
                    })
                    .then((a) => {
                        a.present();
                    });
            }
        },
    },
    computed: {
        summeSpontanEinzahlungen() {
            let result = 0;
            if (
                "summeSpontanEinzahlungen" in
                this.$store.state.spontanrueckzahlung.details
            ) {
                result = parseCurrencyToFloat(
                    this.$store.state.spontanrueckzahlung.details
                        .summeSpontanEinzahlungen
                );
            }
            return result;
        },
        spontanLimit() {
            let result = 1;
            if (
                "spontanLimit" in this.$store.state.spontanrueckzahlung.details
            ) {
                result = parseCurrencyToFloat(
                    this.$store.state.spontanrueckzahlung.details.spontanLimit
                );
            }
            return result;
        },
        spontanProgress() {
            return this.summeSpontanEinzahlungen / this.spontanLimit;
        },
        aktuellerSaldo() {
            let result = 0;
            if (
                "aktuellerSaldo" in
                this.$store.state.spontanrueckzahlung.details
            ) {
                result = parseCurrencyToFloat(
                    this.$store.state.spontanrueckzahlung.details.aktuellerSaldo
                );
            }
            return result;
        },
        darlehensSumme() {
            let result = 1;
            if (
                "darlehensSumme" in
                this.$store.state.spontanrueckzahlung.details
            ) {
                result = parseCurrencyToFloat(
                    this.$store.state.spontanrueckzahlung.details.darlehensSumme
                );
            }
            return result;
        },
        creditProgress() {
            return this.aktuellerSaldo / this.darlehensSumme;
        },
    },
};
</script>

<style></style>
